import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ExperienceSection from "@/components/experience/ExperienceSection";
import EducationSection from "@/components/EducationSection";
import OrganizationsSection from "@/components/OrganizationsSection";
import SkillsSection from "@/components/skills/SkillsSection";
import ChatSection from "@/components/chat/ChatSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <EducationSection />
      <ExperienceSection />
      <SkillsSection />
      <OrganizationsSection />
      <ChatSection />
      <Footer />
    </div>
  );
};

export default Index;
